import { max } from 'lodash';
import { fillDataArrayWithEmptyData } from '../../../utils/p-functions/temporal';

const filterKeywordResponseByNgramsAndAddTopicInfo = (data, ngramsSize) =>
	data.map(dataRow => {
		var result = [];
		for (var i = 0, len = dataRow.response.length; i < len; i += 1) {
			var keyword = dataRow.response[i];
			var displayName = keyword.term[dataRow.request.search.language()];
			var escapedTag = escape(displayName)
				.split('%')
				.join('');
			var dashes = displayName.split(' ').length - 1;

			if (dashes <= ngramsSize - 1) {
				const tag = {
					name: displayName,
					language: keyword.language,
					count: keyword.count,
					id: escapedTag,
					sentiment: keyword.sentiment,
					key: keyword.key,
					topic: dataRow.request.topic,
					displayName
				};

				result.push(tag);
			}
		}
		return result;
	});

const sortKeywords = data => {
	// reverse sort keywords by count so we can select the top keywords afterwards
	// and get the top count to normalize size
	data.sort(function(a, b) {
		if (a.count < b.count) {
			return 1;
		}
		if (a.count > b.count) {
			return -1;
		}

		// if the compared keyword have the same term frequeny we
		// sort by keyword name as a secondary dimension
		if (a.name < b.name) {
			return 1;
		}
		if (a.name > b.name) {
			return -1;
		}
		return 0;
	});

	return data;
};

const calculateAggregateValuesKeywordData = (groupedData, threshold) => {
	let t = null;
	if (!isNaN(threshold)) {
		t = threshold;
	} else {
		t =
			typeof portal_settings !== 'undefined' && portal_settings && portal_settings.tagcloudThreshold
				? portal_settings.tagcloudThreshold / 100
				: 0.6;
	}

	return Object.values(groupedData).map(group => {
		if (group.length === 1) {
			return group[0];
		} else {
			const totalCounts = group.reduce((total, cur) => total + cur.count, 0);
			const avgsent = group.reduce((avg, cur) => avg + (cur.count / totalCounts) * cur.sentiment, 0);
			const aboveThreshold = group.filter(x => x.count > totalCounts * t);
			const topic = aboveThreshold.length === 0 ? null : max(aboveThreshold, 'count').topic;
			return Object.assign({}, group[0], { topic, sentiment: avgsent, count: totalCounts });
		}
	});
};

const calculcateTagLimitByWidthAndHeight = dim => Math.round(Math.sqrt(dim[0] * dim[1]) / 4);

const mergeWithTagLimit = (data, limit) => {
	if (limit === 0) {
		return [];
	}
	const weightFactor = 8; //the higher the factor the more keywords with higher counts will be in returned list eventually
	const limitPerTopic = Math.ceil(limit / data.length) + weightFactor;
	return data.reduce((acc, keywords) => acc.concat(keywords.slice(0, limitPerTopic)), []);
};

const fillTemporalResponseMissingData = (responses, slotParams) => {
	responses.forEach(resp => {
		fillDataArrayWithEmptyData(resp.response, { keywords: [] }, slotParams);
	});
	return responses;
};

const collectTagcloudResponseSlotted = (responses, timeSlot) => {
	return {
		data: responses.map(topic => {
			return topic.response[timeSlot].keywords.map(keyword => {
				const displayName = keyword.term[topic.request.search.language()];
				const escapedTag = escape(displayName).split('%').join('');
				return {
					name: displayName,
					language: keyword.language,
					count: keyword.count,
					id: escapedTag,
					sentiment: keyword.sentiment,
					key: keyword.key,
					topic: topic.request.topic,
					displayName
				};
			});
		}),
		isSlotted: true
	};
};

const mergeTemporalTagcloudData = slotData => {
	const mergedData = {};
	const threshold = portal_settings.tagcloudThreshold / 100;
	slotData.data.forEach(topicData => {
		topicData.forEach(keyword => {
			if (mergedData[keyword.id]) {
				if (mergedData[keyword.id].count < keyword.data) {
					mergedData[keyword.id] = keyword;
				}
				mergedData[keyword.id].crosskeywordCount += keyword.count;
			} else {
				mergedData[keyword.id] = { ...keyword, crosskeywordCount: 0 };
			}
		});
	});
	Object.values(mergedData).forEach(keyword => {
		if (keyword.count < keyword.crosskeywordCount * threshold) {
			keyword.topic = null;
		}
	});
	return {
		...slotData,
		data: Object.values(mergedData)
	};
};

export {
	calculateAggregateValuesKeywordData,
	calculcateTagLimitByWidthAndHeight,
	filterKeywordResponseByNgramsAndAddTopicInfo,
	fillTemporalResponseMissingData,
	mergeWithTagLimit,
	mergeTemporalTagcloudData,
	sortKeywords,
	collectTagcloudResponseSlotted
};
